import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import { errorWithStack } from '@utils/logger'

export const proposalService = async (regNo, mobileNo = '') => {
  try {
    const proposalData = API_URL_FACTORY.PROPOSAL_FETCH(regNo, mobileNo)
    const response = await fetch(proposalData)
    const data = await response.json()
    return data
  } catch (e) {
    errorWithStack('error fetching deep link', e)
  }
}
